(() => {
  const QUESTIONS = [
    {
      id: "level",
      title: "Level kamu sekarang?",
      desc: "Pilih level yang paling mendekati permainan kamu saat ini.",
      options: [
        { value: "new", label: "Baru Mulai", desc: "Kurang dari 2 bulan main padel." },
        { value: "beginner", label: "Beginner", desc: "Sudah sering social match dan mulai nyaman rally." },
        { value: "intermediate", label: "Intermediate", desc: "Mulai kompetitif / upper beginner / gaya main mulai jelas." },
        { value: "advanced", label: "Advanced / Pro", desc: "Silver++ / rutin turnamen / butuh performa tinggi." }
      ]
    },
    {
      id: "frequency",
      title: "Seberapa sering kamu main padel?",
      desc: "Frekuensi main membantu kami membaca kebutuhan durability dan performa.",
      options: [
        { value: "occasional", label: "Kadang-kadang", desc: "1–2x per bulan." },
        { value: "weekly", label: "Rutin mingguan", desc: "1–2x per minggu." },
        { value: "frequent", label: "Sering", desc: "3x atau lebih per minggu." },
        { value: "competitive", label: "Kompetitif / latihan serius", desc: "Sparring, liga, turnamen, atau latihan rutin." }
      ]
    },
    {
      id: "problem",
      title: "Racket sekarang kurangnya di mana?",
      desc: "Pilih problem yang paling terasa saat main.",
      options: [
        { value: "control_out", label: "Bola sering out / susah kontrol", desc: "Butuh racket yang lebih mudah dikontrol." },
        { value: "power_lack", label: "Kurang power / bola kurang keluar", desc: "Butuh bantuan power dan output bola." },
        { value: "tired", label: "Tangan/bahu cepat capek", desc: "Butuh racket yang lebih nyaman dan tidak terlalu demanding." },
        { value: "defense", label: "Susah defense / telat gerak", desc: "Butuh racket yang lebih mudah digerakkan." },
        { value: "upgrade", label: "Racket sekarang sudah oke, mau upgrade", desc: "Butuh performa lebih tinggi." },
        { value: "no_racket", label: "Belum punya racket sendiri", desc: "Butuh pilihan aman untuk mulai." }
      ]
    },
    {
      id: "goal",
      title: "Target utama racket baru kamu?",
      desc: "Pilih tujuan paling penting dari racket baru.",
      options: [
        { value: "control", label: "Lebih kontrol", desc: "Arah bola, konsistensi, dan permainan lebih aman." },
        { value: "power", label: "Lebih power", desc: "Bola lebih keluar, smash lebih tajam, serangan lebih kuat." },
        { value: "comfort", label: "Lebih nyaman", desc: "Prioritas tangan, siku, atau bahu lebih aman." },
        { value: "faster", label: "Lebih cepat digerakkan", desc: "Defense, volley, dan transisi lebih cepat." },
        { value: "allround", label: "All-round", desc: "Aman untuk banyak gaya main." },
        { value: "value", label: "Best value", desc: "Paling worth it dari harga dan performa." }
      ]
    },
    {
      id: "side",
      title: "Kamu biasa main di sisi mana?",
      desc: "Kalau belum tahu, pilih rotasi.",
      options: [
        { value: "left", label: "Kiri / Left Side", desc: "Point finisher, lebih sering attack dan smash." },
        { value: "right", label: "Kanan / Right Side", desc: "Defender control, build point dan jaga rally." },
        { value: "hybrid", label: "Hybrid / Dua sisi", desc: "Fleksibel attack dan defense." },
        { value: "unknown", label: "Belum tahu / masih rotasi", desc: "Masih cari posisi paling cocok." }
      ]
    },
    {
      id: "behavior",
      title: "Pola main kamu paling mendekati yang mana?",
      desc: "Pilih gaya main yang paling sering muncul.",
      options: [
        { value: "safe_rally", label: "Sabar rally dan cari aman", desc: "Bangun poin stabil dan minim error." },
        { value: "counter_defense", label: "Counter dan defense dulu", desc: "Bertahan dan menunggu momentum." },
        { value: "net_play", label: "Sering maju volley / net play", desc: "Ambil posisi depan dan pressure lawan." },
        { value: "attack_finish", label: "Suka attack dan finish point", desc: "Menyerang, smash, vibora, menyelesaikan poin." },
        { value: "mixed", label: "Campur semua", desc: "Kadang attack, kadang defense." }
      ]
    },
    {
      id: "injury",
      title: "Ada concern tangan, siku, atau bahu?",
      desc: "Ini penting supaya rekomendasi tidak terlalu demanding.",
      options: [
        { value: "none", label: "Tidak ada", desc: "Tidak ada masalah khusus." },
        { value: "tired", label: "Kadang tangan/bahu terasa capek", desc: "Butuh racket lebih nyaman." },
        { value: "elbow_shoulder", label: "Ada concern elbow/shoulder", desc: "Prioritas racket aman dan mudah digunakan." },
        { value: "unknown", label: "Belum tahu", desc: "Sistem akan pilih opsi yang aman." }
      ]
    },
    {
      id: "weight",
      title: "Berat racket yang kamu prefer?",
      desc: "Berat mengikuti range dari brand. Request berat spesifik bisa ditulis saat checkout.",
      options: [
        { value: "light", label: "Ringan", desc: "Di bawah 360g, lebih mudah digerakkan." },
        { value: "medium", label: "Medium", desc: "361–375g, range umum racket padel." },
        { value: "no_pref", label: "Tidak masalah", desc: "Sistem pilih berdasarkan kebutuhan dan gaya main." }
      ]
    },
    {
      id: "budget",
      title: "Budget kamu?",
      desc: "Budget membantu kami pilih rekomendasi yang tetap realistis.",
      options: [
        { value: "under2", label: "Dibawah 2Jt", desc: "Cari pilihan paling worth it di bawah 2 juta." },
        { value: "2to3", label: "2–3Jt", desc: "Range value-performance." },
        { value: "3to5", label: "3–5Jt", desc: "Range premium dengan performa lebih tinggi." },
        { value: "above5", label: "5Jt+", desc: "Top-tier / performance terbaik." },
        { value: "no_limit", label: "Yang penting cocok", desc: "Budget tidak jadi batas utama." }
      ]
    },
    {
      id: "brand",
      title: "Ada brand yang kamu prefer?",
      desc: "Brand preference hanya boost kecil, bukan filter keras.",
      options: [
        { value: "adidas", label: "Adidas", desc: "Boost kecil jika brand cocok." },
        { value: "bullpadel", label: "Bullpadel", desc: "Boost kecil jika brand cocok." },
        { value: "nox", label: "NOX", desc: "Boost kecil jika brand cocok." },
        { value: "head", label: "Head", desc: "Boost kecil jika brand cocok." },
        { value: "babolat", label: "Babolat", desc: "Boost kecil jika brand cocok." },
        { value: "wilson", label: "Wilson", desc: "Boost kecil jika brand cocok." },
        { value: "siux", label: "Siux", desc: "Boost kecil jika brand cocok." },
        { value: "none", label: "Tidak ada preferensi", desc: "Rekomendasi fokus ke kecocokan." }
      ]
    }
  ];

  const MILLION_CENTS = 1000000 * 100;

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-racket-finder]").forEach(initFinder);
  });

  function initFinder(root) {
    const hero = root.querySelector("[data-rf-hero]");
    const quiz = root.querySelector("[data-rf-quiz]");
    const questionEl = root.querySelector("[data-rf-question]");
    const resultsEl = root.querySelector("[data-rf-results]");
    const jsonEl = root.querySelector("[data-racket-products-json]");

    let products = [];
    try {
      products = JSON.parse(jsonEl ? jsonEl.textContent : "[]");
    } catch (error) {
      products = [];
    }

    const state = {
      index: 0,
      answers: {},
      top3: []
    };

    const startBtn = root.querySelector("[data-start-finder]");
    if (startBtn) {
      startBtn.addEventListener("click", () => {
        hero.hidden = true;
        quiz.hidden = false;
        resultsEl.hidden = true;
        renderQuestion(root, questionEl, state);
      });
    }

    resultsEl.addEventListener("click", async (event) => {
      const addBtn = event.target.closest("[data-add-cart]");
      const compareBtn = event.target.closest("[data-compare-top]");
      const showMoreBtn = event.target.closest("[data-show-more]");
      const restartBtn = event.target.closest("[data-restart]");
      const chatBtn = event.target.closest("[data-chat-advisor]");

      if (addBtn) {
        await addToCart(addBtn.dataset.addCart, addBtn);
      }

      if (compareBtn) {
        const compare = resultsEl.querySelector("[data-compare-table]");
        if (compare) {
          compare.hidden = !compare.hidden;
          compare.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }

      if (showMoreBtn) {
        resultsEl.querySelectorAll("[data-more-hidden]").forEach((el) => {
          el.hidden = false;
          el.removeAttribute("data-more-hidden");
        });
        showMoreBtn.hidden = true;
      }

      if (restartBtn) {
        state.index = 0;
        state.answers = {};
        state.top3 = [];
        resultsEl.hidden = true;
        quiz.hidden = false;
        renderQuestion(root, questionEl, state);
      }

      if (chatBtn) {
        const url = buildWhatsAppUrl(root, state);
        window.open(url, "_blank");
      }
    });

    root._rfRenderResults = () => {
      renderResults(root, products, state);
    };
  }

  function renderQuestion(root, questionEl, state) {
    const q = QUESTIONS[state.index];
    const progress = Math.round(((state.index + 1) / QUESTIONS.length) * 100);

    root.querySelector("[data-rf-step-label]").textContent = `Step ${state.index + 1} of ${QUESTIONS.length}`;
    root.querySelector("[data-rf-progress-percent]").textContent = `${progress}%`;
    root.querySelector("[data-rf-progress-bar]").style.width = `${progress}%`;

    questionEl.innerHTML = `
      <div class="rf__question-kicker">Racket Finder</div>
      <h2 class="rf__question-title">${escapeHtml(q.title)}</h2>
      <p class="rf__question-desc">${escapeHtml(q.desc)}</p>

      <div class="rf__options">
        ${q.options.map((option) => `
          <button class="rf__option" type="button" data-answer="${escapeHtml(option.value)}">
            <span class="rf__option-title">${escapeHtml(option.label)}</span>
            <span class="rf__option-desc">${escapeHtml(option.desc)}</span>
          </button>
        `).join("")}
      </div>

      <div class="rf__nav">
        <button class="rf__ghost-btn" type="button" data-back ${state.index === 0 ? "disabled" : ""}>
          Back
        </button>
        <button class="rf__ghost-btn" type="button" data-restart-mini>
          Restart
        </button>
      </div>
    `;

    questionEl.querySelectorAll("[data-answer]").forEach((btn) => {
      btn.addEventListener("click", () => {
        state.answers[q.id] = btn.dataset.answer;

        if (state.index < QUESTIONS.length - 1) {
          state.index += 1;
          renderQuestion(root, questionEl, state);
        } else {
          const quiz = root.querySelector("[data-rf-quiz]");
          quiz.hidden = true;
          root._rfRenderResults();
        }
      });
    });

    const backBtn = questionEl.querySelector("[data-back]");
    if (backBtn) {
      backBtn.addEventListener("click", () => {
        if (state.index > 0) {
          state.index -= 1;
          renderQuestion(root, questionEl, state);
        }
      });
    }

    const restartBtn = questionEl.querySelector("[data-restart-mini]");
    if (restartBtn) {
      restartBtn.addEventListener("click", () => {
        state.index = 0;
        state.answers = {};
        renderQuestion(root, questionEl, state);
      });
    }
  }

  function renderResults(root, products, state) {
    const resultsEl = root.querySelector("[data-rf-results]");
    resultsEl.hidden = false;

    const scored = products
      .map((product) => scoreProduct(product, state.answers))
      .filter(Boolean)
      .filter((item) => item.score >= 60)
      .sort((a, b) => b.score - a.score);

    if (!products.length) {
      resultsEl.innerHTML = `
        <div class="rf__empty">
          <h2>Collection belum dipilih atau produk belum kebaca.</h2>
          <p>Pilih collection Racket Finder Products di Theme Editor, lalu pastikan produk punya metafield dan inventory aktif.</p>
          <button class="rf__secondary-btn" type="button" data-restart>Restart</button>
        </div>
      `;
      return;
    }

    if (!scored.length) {
      resultsEl.innerHTML = `
        <div class="rf__empty">
          <h2>Belum ada racket yang match dengan jawaban kamu.</h2>
          <p>Kemungkinan stok sedang kosong atau data metafield belum lengkap. Coba chat advisor untuk rekomendasi manual.</p>
          <div class="rf__actions">
            <button class="rf__secondary-btn" type="button" data-chat-advisor>Chat Advisor</button>
            <button class="rf__ghost-btn" type="button" data-restart>Ulangi Finder</button>
          </div>
        </div>
      `;
      return;
    }

    const top3 = pickTopRecommendations(scored, state.answers);
    state.top3 = top3;

    const more = scored
      .filter((item) => !top3.some((top) => top.product.id === item.product.id))
      .slice(0, 12);

    resultsEl.innerHTML = `
      <div class="rf__result-header">
        <h2>Top Racket Picks for You</h2>
        <p>${escapeHtml(buildDynamicSubcopy(state.answers))}</p>
      </div>

      <div class="rf__top-grid">
        ${top3.map((item, index) => renderRecommendationCard(item, index, state.answers)).join("")}
      </div>

      <div class="rf__mini-section">
        <h2>Compare Top 3 Rackets</h2>
        <p>Lihat perbandingan power, control, rebound, maneuverability, dan sweetspot dari rekomendasi utama kamu.</p>
        <button class="rf__secondary-btn" type="button" data-compare-top>Compare Top 3</button>

        <div class="rf__table-wrap" data-compare-table hidden>
          ${renderCompareTable(top3)}
        </div>
      </div>

      ${more.length ? `
        <div class="rf__mini-section">
          <h2>Pilihan lain yang juga cocok</h2>
          <p>Masih sesuai dengan jawaban kamu, tapi bukan rekomendasi utama.</p>

          <div class="rf__more-grid">
            ${more.map((item, index) => renderMiniCard(item, index)).join("")}
          </div>

          ${more.length > 4 ? `
            <div style="margin-top:18px;">
              <button class="rf__ghost-btn" type="button" data-show-more>Show More</button>
            </div>
          ` : ""}
        </div>
      ` : ""}

      <div class="rf__mini-section">
        <h2>Masih ragu?</h2>
        <p>Chat advisor padeltop dan kirim hasil rekomendasi kamu untuk dibantu pilih final.</p>
        <div class="rf__actions">
          <button class="rf__secondary-btn" type="button" data-chat-advisor>Chat Advisor</button>
          <button class="rf__ghost-btn" type="button" data-restart>Ulangi Finder</button>
        </div>
      </div>
    `;
  }

  function pickTopRecommendations(scored, answers) {
    const used = new Set();

    const bestMatch =
      scored.find((item) => item.customerFit >= 70) ||
      scored[0];

    if (bestMatch) used.add(bestMatch.product.id);

    const valueCandidates = scored
      .filter((item) => !used.has(item.product.id))
      .sort((a, b) => {
        const aRank = a.score + (a.budgetFit * 2) + affordabilityBoost(a.product.price);
        const bRank = b.score + (b.budgetFit * 2) + affordabilityBoost(b.product.price);
        return bRank - aRank;
      });

    const bestValue = valueCandidates[0];
    if (bestValue) used.add(bestValue.product.id);

    const upgradeCandidates = scored
      .filter((item) => !used.has(item.product.id))
      .sort((a, b) => {
        const aRank = a.score + performanceAverage(a.product) * 4 + premiumBoost(a.product);
        const bRank = b.score + performanceAverage(b.product) * 4 + premiumBoost(b.product);
        return bRank - aRank;
      });

    const upgradePick = upgradeCandidates[0];

    return [
      bestMatch ? { ...bestMatch, cardLabel: "Best Match" } : null,
      bestValue ? { ...bestValue, cardLabel: "Best Value" } : null,
      upgradePick ? { ...upgradePick, cardLabel: "Upgrade Pick" } : null
    ].filter(Boolean);
  }

  function scoreProduct(product, answers) {
    const stock = Number(product.stock_quantity || 0);

    if (stock <= 0) return null;

    const playerProfileFit = scorePlayerProfile(product, answers);
    const problemGoalFit = scoreProblemGoal(product, answers);
    const playStyleFit = scorePlayStyle(product, answers);
    const comfortInjuryFit = scoreComfortInjury(product, answers);
    const performanceFit = scorePerformanceFit(product, answers);
    const budgetData = scoreBudget(product, answers);
    const stockPriority = getStockPriorityScore(stock);
    const brandBoost = getBrandBoost(product, answers);
    const penalty = getPenalty(product, answers, budgetData);

    const rawScore =
      playerProfileFit +
      problemGoalFit +
      playStyleFit +
      comfortInjuryFit +
      performanceFit +
      budgetData.score +
      stockPriority +
      brandBoost -
      penalty;

    const score = clamp(Math.round(rawScore), 0, 100);
    const customerFit = clamp(Math.round(rawScore - stockPriority), 0, 100);

    return {
      product,
      score,
      customerFit,
      playerProfileFit,
      problemGoalFit,
      playStyleFit,
      comfortInjuryFit,
      performanceFit,
      budgetFit: budgetData.score,
      stockPriority,
      brandBoost,
      penalty,
      tag: deriveTag(product, answers)
    };
  }

  function scorePlayerProfile(p, a) {
    let levelScore = 0;
    let frequencyScore = 0;

    if (a.level === "new") {
      levelScore += isProductLevel(p, "beginner") ? 4 : 0;
      levelScore += isRound(p) ? 2 : 0;
      levelScore += isControlType(p) || isAllRoundType(p) ? 2 : 0;
      levelScore += metric(p, "sweetspot_score") * 0.25;
      levelScore += metric(p, "maneuverability_score") * 0.2;
    }

    if (a.level === "beginner") {
      levelScore += isProductLevel(p, "beginner") || isProductLevel(p, "intermediate") ? 4 : 0;
      levelScore += isControlType(p) || isAllRoundType(p) ? 2 : 0;
      levelScore += metric(p, "sweetspot_score") * 0.3;
      levelScore += metric(p, "maneuverability_score") * 0.2;
    }

    if (a.level === "intermediate") {
      levelScore += isProductLevel(p, "intermediate") || isProductLevel(p, "advanced") ? 4 : 0;
      levelScore += isTeardrop(p) || isAllRoundType(p) ? 3 : 0;
      levelScore += performanceAverage(p) * 0.45;
    }

    if (a.level === "advanced") {
      levelScore += isAdvancedProduct(p) ? 4 : 0;
      levelScore += isCarbon(p) ? 2 : 0;
      levelScore += performanceAverage(p) * 0.6;
    }

    if (a.frequency === "occasional") {
      frequencyScore += metric(p, "sweetspot_score") * 0.25;
      frequencyScore += isSoftInner(p) || isFiberglass(p) ? 2 : 0;
      frequencyScore += isControlType(p) || isAllRoundType(p) ? 2 : 0;
    }

    if (a.frequency === "weekly") {
      frequencyScore += isAllRoundType(p) || isBalanced(p) ? 3 : 0;
      frequencyScore += performanceAverage(p) * 0.35;
      frequencyScore += isTeardrop(p) ? 1 : 0;
    }

    if (a.frequency === "frequent") {
      frequencyScore += isCarbon(p) ? 3 : 0;
      frequencyScore += performanceAverage(p) * 0.45;
      frequencyScore += isMediumInner(p) || isHardInner(p) ? 1 : 0;
    }

    if (a.frequency === "competitive") {
      frequencyScore += isAdvancedProduct(p) ? 3 : 0;
      frequencyScore += isCarbon(p) ? 2 : 0;
      frequencyScore += performanceAverage(p) * 0.45;
    }

    return clamp(levelScore, 0, 12) + clamp(frequencyScore, 0, 8);
  }

  function scoreProblemGoal(p, a) {
    const problemIntent = {
      control_out: "control",
      power_lack: "power",
      tired: "comfort",
      defense: "speed",
      upgrade: "upgrade",
      no_racket: "safe"
    }[a.problem] || "allround";

    const goalIntent = {
      control: "control",
      power: "power",
      comfort: "comfort",
      faster: "speed",
      allround: "allround",
      value: "value"
    }[a.goal] || "allround";

    return scoreIntentFit(p, problemIntent, 12) + scoreIntentFit(p, goalIntent, 13);
  }

  function scorePlayStyle(p, a) {
    let sideScore = 0;

    if (a.side === "left") {
      sideScore += metric(p, "power_score") * 0.25;
      sideScore += metric(p, "rebound_score") * 0.2;
      sideScore += isDiamond(p) || isTeardrop(p) ? 2 : 0;
      sideScore += isHighBalance(p) ? 1 : 0;
    }

    if (a.side === "right") {
      sideScore += metric(p, "control_score") * 0.3;
      sideScore += metric(p, "maneuverability_score") * 0.25;
      sideScore += metric(p, "sweetspot_score") * 0.2;
      sideScore += isRound(p) || isTeardrop(p) ? 1.5 : 0;
    }

    if (a.side === "hybrid") {
      sideScore += scoreIntentFit(p, "allround", 8);
      sideScore += isBalanced(p) || isTeardrop(p) ? 2 : 0;
    }

    if (a.side === "unknown") {
      sideScore += scoreIntentFit(p, "safe", 10);
    }

    const behaviorIntent = {
      safe_rally: "control",
      counter_defense: "speed",
      net_play: "speed",
      attack_finish: "power",
      mixed: "allround"
    }[a.behavior] || "allround";

    let behaviorScore = scoreIntentFit(p, behaviorIntent, 10);

    if (a.behavior === "net_play") {
      behaviorScore += isCarbon(p) || isMediumInner(p) ? 1 : 0;
    }

    return clamp(sideScore, 0, 10) + clamp(behaviorScore, 0, 10);
  }

  function scoreComfortInjury(p, a) {
    let injuryScore = 0;

    if (a.injury === "none") {
      injuryScore = 10.5;
    }

    if (a.injury === "tired") {
      injuryScore = scoreIntentFit(p, "comfort", 11);
    }

    if (a.injury === "elbow_shoulder") {
      injuryScore = scoreIntentFit(p, "comfort", 11);
      injuryScore += isRound(p) || isTeardrop(p) ? 1 : 0;
    }

    if (a.injury === "unknown") {
      injuryScore = scoreIntentFit(p, "safe", 11);
    }

    let weightScore = 4;

    if (a.weight === "light") {
      weightScore = 0;
      weightScore += isLightWeight(p) ? 2 : 0;
      weightScore += metric(p, "maneuverability_score") * 0.15;
      weightScore += isLowBalance(p) || isRound(p) ? 0.8 : 0;
    }

    if (a.weight === "medium") {
      weightScore = 0;
      weightScore += isMediumWeight(p) ? 2 : 0;
      weightScore += isBalanced(p) || isTeardrop(p) ? 1 : 0;
      weightScore += performanceAverage(p) * 0.1;
    }

    return clamp(injuryScore, 0, 11) + clamp(weightScore, 0, 4);
  }

  function scorePerformanceFit(p, a) {
    const intent = detectPerformanceIntent(a);

    const weights = {
      control: { power: 0.10, control: 0.35, rebound: 0.10, maneuverability: 0.20, sweetspot: 0.25 },
      power: { power: 0.35, control: 0.15, rebound: 0.30, maneuverability: 0.10, sweetspot: 0.10 },
      comfort: { power: 0.10, control: 0.20, rebound: 0.10, maneuverability: 0.35, sweetspot: 0.25 },
      allround: { power: 0.20, control: 0.25, rebound: 0.20, maneuverability: 0.20, sweetspot: 0.15 },
      right: { power: 0.10, control: 0.35, rebound: 0.10, maneuverability: 0.25, sweetspot: 0.20 },
      left: { power: 0.30, control: 0.15, rebound: 0.25, maneuverability: 0.15, sweetspot: 0.15 }
    }[intent] || { power: 0.20, control: 0.25, rebound: 0.20, maneuverability: 0.20, sweetspot: 0.15 };

    return (
      metric(p, "power_score") * weights.power +
      metric(p, "control_score") * weights.control +
      metric(p, "rebound_score") * weights.rebound +
      metric(p, "maneuverability_score") * weights.maneuverability +
      metric(p, "sweetspot_score") * weights.sweetspot
    );
  }

  function scoreIntentFit(p, intent, max) {
    const power = metric01(p, "power_score");
    const control = metric01(p, "control_score");
    const rebound = metric01(p, "rebound_score");
    const maneuverability = metric01(p, "maneuverability_score");
    const sweetspot = metric01(p, "sweetspot_score");

    const stability = average([
      isCarbon(p) ? 1 : 0.45,
      isMediumInner(p) || isHardInner(p) ? 1 : 0.55,
      isTeardrop(p) || isDiamond(p) ? 1 : 0.55
    ]);

    const safeSpec = average([
      isRound(p) || isTeardrop(p) ? 1 : 0.35,
      isLowBalance(p) || isBalanced(p) ? 1 : 0.35,
      isSoftInner(p) || isMediumInner(p) ? 1 : 0.45
    ]);

    const reboundControl = rebound <= 0.78 ? 1 : rebound <= 0.83 ? 0.75 : rebound <= 0.87 ? 0.35 : 0.15;
    const reboundAllround = rebound >= 0.65 && rebound <= 0.84 ? 1 : 0.55;

    let score = 0;

    if (intent === "control") {
      score = max * (
        control * 0.35 +
        sweetspot * 0.25 +
        maneuverability * 0.15 +
        reboundControl * 0.15 +
        (isRound(p) ? 1 : isTeardrop(p) ? 0.7 : 0.25) * 0.10
      );
    }

    if (intent === "power") {
      score = max * (
        power * 0.35 +
        rebound * 0.30 +
        stability * 0.20 +
        sweetspot * 0.10 +
        (isDiamond(p) || isTeardrop(p) ? 1 : 0.35) * 0.05
      );
    }

    if (intent === "comfort") {
      score = max * (
        maneuverability * 0.35 +
        sweetspot * 0.30 +
        safeSpec * 0.20 +
        control * 0.15
      );
    }

    if (intent === "speed") {
      score = max * (
        maneuverability * 0.45 +
        control * 0.20 +
        sweetspot * 0.20 +
        (isLightWeight(p) || isLowBalance(p) ? 1 : 0.55) * 0.15
      );
    }

    if (intent === "allround") {
      score = max * (
        control * 0.25 +
        power * 0.20 +
        reboundAllround * 0.15 +
        maneuverability * 0.20 +
        sweetspot * 0.15 +
        (isAllRoundType(p) || isTeardrop(p) || isBalanced(p) ? 1 : 0.5) * 0.05
      );
    }

    if (intent === "value") {
      score = max * (
        performanceAverage(p) / 10 * 0.55 +
        safeSpec * 0.20 +
        (isAllRoundType(p) || isFiberglass(p) ? 1 : 0.55) * 0.25
      );
    }

    if (intent === "upgrade") {
      score = max * (
        performanceAverage(p) / 10 * 0.50 +
        premiumBoost(p) / 5 * 0.30 +
        stability * 0.20
      );
    }

    if (intent === "safe") {
      score = max * (
        sweetspot * 0.35 +
        control * 0.25 +
        maneuverability * 0.20 +
        safeSpec * 0.20
      );
    }

    return clamp(score, 0, max);
  }

  function scoreBudget(p, a) {
    const price = Number(p.price || 0);

    if (a.budget === "no_limit") {
      return { score: 5, mismatch: false };
    }

    const ranges = {
      under2: [0, 2 * MILLION_CENTS],
      "2to3": [2 * MILLION_CENTS, 3 * MILLION_CENTS],
      "3to5": [3 * MILLION_CENTS, 5 * MILLION_CENTS],
      above5: [5 * MILLION_CENTS, Infinity]
    };

    const range = ranges[a.budget];

    if (!range) return { score: 5, mismatch: false };

    const [min, max] = range;

    if (price >= min && price <= max) {
      return { score: 5, mismatch: false };
    }

    const nearAbove =
      Number.isFinite(max) &&
      price > max &&
      price <= max + 0.5 * MILLION_CENTS;

    if (nearAbove) {
      return { score: 3, mismatch: false };
    }

    return { score: 0, mismatch: true };
  }

  function getPenalty(p, a, budgetData) {
    let penalty = 0;

    const injuryConcern =
      a.problem === "tired" ||
      a.goal === "comfort" ||
      a.injury === "tired" ||
      a.injury === "elbow_shoulder";

    const controlConcern =
      a.problem === "control_out" ||
      a.goal === "control" ||
      a.behavior === "safe_rally";

    const beginnerSafety =
      a.level === "new" ||
      a.problem === "no_racket";

    if (injuryConcern) {
      if (isHighBalance(p)) penalty += 10;
      if (isDiamond(p)) penalty += 8;
      if (isPowerType(p)) penalty += 8;
      if (isAdvancedProduct(p)) penalty += 8;
      if (metric(p, "sweetspot_score") < 7) penalty += 10;
      if (metric(p, "maneuverability_score") < 7) penalty += 10;
    }

    if (controlConcern) {
      if (metric(p, "rebound_score") > 8.3) penalty += 8;
      if (metric(p, "power_score") > 8.3 && metric(p, "control_score") < 8) penalty += 10;
      if (isHighBalance(p)) penalty += 6;
      if (isDiamond(p)) penalty += 5;
    }

    if (beginnerSafety) {
      if (isAdvancedProduct(p)) penalty += 10;
      if (isDiamond(p)) penalty += 8;
      if (isHighBalance(p)) penalty += 8;
      if (metric(p, "rebound_score") > 8.3) penalty += 5;
    }

    if (budgetData.mismatch && a.budget !== "no_limit") {
      penalty += 10;
    }

    return penalty;
  }

  function detectPerformanceIntent(a) {
    if (a.injury === "tired" || a.injury === "elbow_shoulder" || a.problem === "tired" || a.goal === "comfort") {
      return "comfort";
    }

    if (a.problem === "control_out" || a.goal === "control" || a.behavior === "safe_rally") {
      return "control";
    }

    if (a.problem === "power_lack" || a.goal === "power" || a.behavior === "attack_finish") {
      return "power";
    }

    if (a.side === "right") return "right";
    if (a.side === "left") return "left";

    return "allround";
  }

  function getStockPriorityScore(stock) {
    if (stock >= 20) return 5;
    if (stock >= 10) return 4;
    if (stock >= 5) return 3;
    if (stock >= 2) return 2;
    if (stock >= 1) return 1;
    return 0;
  }

  function getBrandBoost(p, a) {
    if (!a.brand || a.brand === "none") return 0;
    return norm(p.brand || p.vendor).includes(a.brand) ? 4 : 0;
  }

  function renderRecommendationCard(item, index, answers) {
    const p = item.product;
    const reasons = buildReasons(item, answers);
    const comparePrice = Number(p.compare_at_price || 0);
    const price = Number(p.price || 0);

    return `
      <article class="rf__card">
        <a class="rf__card-image" href="${escapeAttr(p.url)}">
          ${p.image ? `<img src="${escapeAttr(p.image)}" alt="${escapeAttr(p.title)}" loading="lazy">` : ""}
          <span class="rf__badge">${escapeHtml(item.cardLabel)}</span>
          <span class="rf__match">${item.score}% cocok</span>
        </a>

        <div class="rf__card-body">
          <span class="rf__tag">${escapeHtml(item.tag)}</span>
          <h3>${escapeHtml(p.title)}</h3>

          <div class="rf__price">
            ${formatMoney(price)}
            ${comparePrice > price ? `<span class="rf__compare-price">${formatMoney(comparePrice)}</span>` : ""}
          </div>

          <ul class="rf__reasons">
            ${reasons.map((reason) => `<li>${escapeHtml(reason)}</li>`).join("")}
          </ul>

          <div class="rf__actions">
            <button class="rf__secondary-btn" type="button" data-add-cart="${escapeAttr(p.variant_id)}">
              Add to Cart
            </button>
            <a class="rf__ghost-btn" href="${escapeAttr(p.url)}">
              View Product
            </a>
            ${index === 0 ? `<button class="rf__ghost-btn" type="button" data-chat-advisor>Chat Advisor</button>` : ""}
          </div>
        </div>
      </article>
    `;
  }

  function renderMiniCard(item, index) {
    const p = item.product;
    const hiddenAttr = index >= 4 ? "hidden data-more-hidden" : "";

    return `
      <a class="rf__mini-card" href="${escapeAttr(p.url)}" ${hiddenAttr}>
        ${p.image ? `<img src="${escapeAttr(p.image)}" alt="${escapeAttr(p.title)}" loading="lazy">` : ""}
        <div class="rf__mini-card-body">
          <span class="rf__tag">${escapeHtml(item.tag)}</span>
          <h3>${escapeHtml(p.title)}</h3>
          <div class="rf__price">${item.score}% cocok</div>
          <div>${formatMoney(p.price)}</div>
        </div>
      </a>
    `;
  }

  function renderCompareTable(items) {
    const rows = [
      ["Match Score", ...items.map((item) => `${item.score}%`)],
      ["Best For", ...items.map((item) => item.tag)],
      ["Power", ...items.map((item) => metric(item.product, "power_score").toFixed(1))],
      ["Control", ...items.map((item) => metric(item.product, "control_score").toFixed(1))],
      ["Rebound", ...items.map((item) => metric(item.product, "rebound_score").toFixed(1))],
      ["Maneuverability", ...items.map((item) => metric(item.product, "maneuverability_score").toFixed(1))],
      ["Sweetspot", ...items.map((item) => metric(item.product, "sweetspot_score").toFixed(1))],
      ["Stock", ...items.map((item) => `${item.product.stock_quantity} pcs`)]
    ];

    return `
      <table class="rf__compare-table">
        <thead>
          <tr>
            <th>Metric</th>
            ${items.map((item) => `<th>${escapeHtml(item.cardLabel)}<br>${escapeHtml(item.product.title)}</th>`).join("")}
          </tr>
        </thead>
        <tbody>
          ${rows.map((row) => `
            <tr>
              ${row.map((cell) => `<td>${escapeHtml(cell)}</td>`).join("")}
            </tr>
          `).join("")}
        </tbody>
      </table>
    `;
  }

  function buildReasons(item, answers) {
    const p = item.product;
    const reasons = [];

    if (answers.side === "left") {
      reasons.push("Kamu main kiri sebagai point finisher, jadi power dan rebound lebih diprioritaskan.");
    }

    if (answers.side === "right") {
      reasons.push("Kamu main kanan, jadi control, maneuverability, dan sweetspot lebih penting.");
    }

    if (answers.problem === "control_out") {
      reasons.push("Kamu sering bola out, jadi racket dengan control dan sweetspot lebih aman diprioritaskan.");
    }

    if (answers.problem === "power_lack" || answers.goal === "power") {
      reasons.push("Kamu mencari tambahan power, jadi output bola dan rebound racket ikut dihitung.");
    }

    if (answers.goal === "comfort" || answers.injury === "tired" || answers.injury === "elbow_shoulder") {
      reasons.push("Kamu punya concern kenyamanan, jadi racket yang terlalu demanding diturunkan skornya.");
    }

    if (item.cardLabel === "Best Value") {
      reasons.push("Pilihan ini tetap cocok, tapi lebih worth it dari sisi harga dan performa.");
    }

    if (item.cardLabel === "Upgrade Pick") {
      reasons.push("Pilihan ini lebih cocok untuk upgrade performa dan permainan yang lebih serius.");
    }

    if (reasons.length < 3) {
      reasons.push(`${p.title} punya profil ${item.tag.toLowerCase()} yang sesuai dengan jawaban kamu.`);
    }

    reasons.push(`Stok tersedia: ${p.stock_quantity} pcs.`);

    return reasons.slice(0, 4);
  }

  function buildDynamicSubcopy(answers) {
    const parts = [];

    const level = getAnswerLabel("level", answers.level);
    const side = getAnswerLabel("side", answers.side);
    const goal = getAnswerLabel("goal", answers.goal);
    const budget = getAnswerLabel("budget", answers.budget);

    if (level) parts.push(level);
    if (side) parts.push(side);
    if (goal) parts.push(goal);
    if (budget) parts.push(`budget ${budget}`);

    return `Kami pilih berdasarkan jawaban kamu: ${parts.join(", ")}.`;
  }

  function buildWhatsAppUrl(root, state) {
    const number = String(root.dataset.waNumber || "6285216336699").replace(/\D/g, "");
    const top = state.top3 || [];

    const lines = [
      "Halo padeltop, saya mau konsultasi hasil Racket Finder.",
      "",
      `Jawaban saya: ${buildDynamicSubcopy(state.answers)}`,
      "",
      "Rekomendasi:"
    ];

    top.forEach((item) => {
      lines.push(`- ${item.cardLabel}: ${item.product.title} (${item.score}% cocok)`);
    });

    return `https://wa.me/${number}?text=${encodeURIComponent(lines.join("\n"))}`;
  }

  async function addToCart(variantId, button) {
    if (!variantId) return;

    const originalText = button.textContent;
    button.textContent = "Adding...";
    button.disabled = true;

    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({
          id: Number(variantId),
          quantity: 1
        })
      });

      if (!response.ok) throw new Error("Add to cart failed");

      button.textContent = "Added";
      window.location.href = "/cart";
    } catch (error) {
      button.textContent = "Failed";
      setTimeout(() => {
        button.textContent = originalText;
        button.disabled = false;
      }, 1600);
    }
  }

  function deriveTag(p, a) {
    if (a.goal === "value") return "Best Value";
    if (a.problem === "power_lack" || a.goal === "power" || a.behavior === "attack_finish") return "Power";
    if (a.problem === "control_out" || a.goal === "control" || a.behavior === "safe_rally") return "Control";
    if (a.goal === "comfort" || a.injury === "tired" || a.injury === "elbow_shoulder") return "Comfort";
    if (a.side === "right" || a.problem === "defense") return "Defense";
    if (isAllRoundType(p) || a.goal === "allround") return "All-round";
    return "Recommended";
  }

  function affordabilityBoost(price) {
    price = Number(price || 0);
    if (price <= 2 * MILLION_CENTS) return 5;
    if (price <= 3 * MILLION_CENTS) return 4;
    if (price <= 5 * MILLION_CENTS) return 2;
    return 0;
  }

  function premiumBoost(p) {
    let score = 0;
    if (isCarbon(p)) score += 2;
    if (isAdvancedProduct(p)) score += 1;
    if (isHardInner(p) || isMediumInner(p)) score += 1;
    if (Number(p.model_year || 0) >= 2025) score += 1;
    return clamp(score, 0, 5);
  }

  function getAnswerLabel(questionId, value) {
    const question = QUESTIONS.find((q) => q.id === questionId);
    const option = question && question.options.find((o) => o.value === value);
    return option ? option.label : "";
  }

  function metric(p, key) {
    return clamp(Number(p[key] || 0), 0, 10);
  }

  function metric01(p, key) {
    return metric(p, key) / 10;
  }

  function performanceAverage(p) {
    return average([
      metric(p, "power_score"),
      metric(p, "control_score"),
      metric(p, "rebound_score"),
      metric(p, "maneuverability_score"),
      metric(p, "sweetspot_score")
    ]);
  }

  function average(arr) {
    const clean = arr.map(Number).filter((n) => !Number.isNaN(n));
    if (!clean.length) return 0;
    return clean.reduce((sum, n) => sum + n, 0) / clean.length;
  }

  function norm(value) {
    return String(value || "").toLowerCase().trim();
  }

  function includes(value, needle) {
    return norm(value).includes(needle);
  }

  function isRound(p) {
    return includes(p.shape, "round");
  }

  function isTeardrop(p) {
    return includes(p.shape, "tear") || includes(p.shape, "hybrid");
  }

  function isDiamond(p) {
    return includes(p.shape, "diamond");
  }

  function isControlType(p) {
    return includes(p.game_type, "control");
  }

  function isPowerType(p) {
    return includes(p.game_type, "power");
  }

  function isAllRoundType(p) {
    return includes(p.game_type, "all") || includes(p.game_type, "round");
  }

  function isLowBalance(p) {
    return includes(p.balance, "low");
  }

  function isBalanced(p) {
    const b = norm(p.balance);
    return b === "balance" || b === "balanced" || b.includes("medium");
  }

  function isHighBalance(p) {
    return includes(p.balance, "high");
  }

  function isSoftInner(p) {
    return includes(p.inner_layer, "soft");
  }

  function isMediumInner(p) {
    return includes(p.inner_layer, "medium");
  }

  function isHardInner(p) {
    return includes(p.inner_layer, "hard");
  }

  function isFiberglass(p) {
    return includes(p.outer_layer, "fiber") || includes(p.outer_layer, "glass");
  }

  function isCarbon(p) {
    return includes(p.outer_layer, "carbon") || includes(p.outer_layer, "12k") || includes(p.outer_layer, "18k");
  }

  function isProductLevel(p, level) {
    return includes(p.level, level);
  }

  function isAdvancedProduct(p) {
    return isProductLevel(p, "advanced") || isProductLevel(p, "pro");
  }

  function isLightWeight(p) {
    const w = norm(p.weight);
    return w.includes("<360") || w.includes("under") || w.includes("light") || w.includes("355") || w.includes("350");
  }

  function isMediumWeight(p) {
    const w = norm(p.weight);
    return w.includes("361") || w.includes("375") || w.includes("medium") || w.includes("360-375");
  }

  function formatMoney(cents) {
    const value = Number(cents || 0) / 100;

    return new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      maximumFractionDigits: 0
    }).format(value);
  }

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, Number(value) || 0));
  }

  function escapeHtml(value) {
    return String(value || "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }

  function escapeAttr(value) {
    return escapeHtml(value);
  }
})();